// extracted by mini-css-extract-plugin
export default {"answerTab":"AnswerTab_answerTab__OCHFa","active":"AnswerTab_active__mG+C-","answer":"AnswerTab_answer__R77jz"};